export default {
    url: process.env.PUBLIC_URL,
    uri: process.env.PUBLIC_URL
    // url: 'http://iobooth.local'
    // url: 'http://iobooth.local'
    // url: 'https://iobooth.gc-dpi.com/' // http://192.168.187.31:5000 http://localhost:5000
}